export default () => (
  <svg width="28" height="38" viewBox="0 0 28 38" fill="none">
    <path
      d="M14 24C17.32 24 20 21.32 20 18V6C20 2.68 17.32 0 14 0C10.68 0 7.99997 2.68 7.99997 6V18C7.99997 21.32 10.68 24 14 24ZM12 6C12 4.9 12.9 4 14 4C15.1 4 16 4.9 16 6V18C16 19.1 15.1 20 14 20C12.9 20 12 19.1 12 18V6ZM25.82 18C24.84 18 24.02 18.72 23.86 19.7C23.04 24.4 18.94 28 14 28C9.05997 28 4.95997 24.4 4.13997 19.7C3.97997 18.72 3.15997 18 2.17997 18C0.959973 18 -2.6986e-05 19.08 0.179973 20.28C1.15997 26.28 5.95997 30.98 12 31.84V36C12 37.1 12.9 38 14 38C15.1 38 16 37.1 16 36V31.84C22.04 30.98 26.84 26.28 27.82 20.28C28.02 19.08 27.04 18 25.82 18Z"
      fill="#42CECE"
    />
  </svg>
);
